<template>
  <div>
    <span v-if="label" class="avatar-uploader-label">{{ label }}</span>
    <woot-thumbnail
      v-if="src"
      size="80px"
      :src="src"
      :username="usernameAvatar"
    />
    <div v-if="src && deleteAvatar" class="avatar-delete-btn">
      <woot-button
        color-scheme="alert"
        variant="hollow"
        size="tiny"
        type="button"
        @click="onAvatarDelete"
      >
        {{ this.$t('INBOX_MGMT.DELETE.AVATAR_DELETE_BUTTON_TEXT') }}
      </woot-button>
    </div>
    <div class="avatar-file-input">
      <input
        id="file"
        ref="file"
        type="file"
        accept="image/png, image/jpeg, image/gif"
        @change="handleImageUpload"
      />
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    src: {
      type: String,
      default: '',
    },
    usernameAvatar: {
      type: String,
      default: '',
    },
    deleteAvatar: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  methods: {
    handleImageUpload(event) {
      const [file] = event.target.files;

      this.$emit('change', {
        file,
        url: file ? URL.createObjectURL(file) : null,
      });
    },
    onAvatarDelete() {
      this.clearFileInput();
      this.$emit('onAvatarDelete');
    },
    clearFileInput() {
      const input = this.$refs.file;
      if (input) {
        input.value = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-uploader-label {
  @apply block text-sm font-medium text-slate-800 dark:text-slate-200 mb-1;
}

.avatar-file-input {
  @apply inline-block w-fit max-w-full px-2.5 py-1.5 rounded-md border border-solid border-slate-300 dark:border-slate-600 bg-slate-50 dark:bg-slate-800;

  input[type='file'] {
    width: auto;
    max-width: 100%;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    font-size: 13px;
  }
}

.avatar-delete-btn {
  margin-top: var(--space-smaller);
  margin-bottom: var(--space-smaller);
}
</style>
